<template>
    <!-- ДОБАВЛЕНО: :contentStyle="{ overflow: 'visible' }" -->
    <Dialog :visible.sync="localVisible" modal closeOnEscape closable :style="{ width: '50vw' }" :contentStyle="{ overflow: 'visible' }">
        <template #header>
            <h3 class="p-mb-0">Массовая загрузка данных</h3>
        </template>

        <div class="p-m-3">
            <div class="dialog-header-sections">
                <div class="form-section">
                    <label for="modal-form-select" class="p-d-block p-mb-2 font-bold">Форма</label>
                    <Dropdown id="modal-form-select" v-model="localSelectedForm" placeholder="Выберите форму" :options="formList" optionLabel="name" dataKey="id" style="width: 100%" class="customDropDown" filter />
                </div>

                <div class="period-section">
                    <label for="modal-period-select" class="p-d-block p-mb-2 font-bold">Отчётный период</label>
                    <!-- ДОБАВЛЕНО: append-to-body -->
                    <Dropdown
                        id="modal-period-select"
                        v-model="localSelectedPeriod"
                        placeholder="Выберите период"
                        :options="periodList"
                        optionLabel="name"
                        dataKey="id"
                        style="width: 100%"
                        class="customDropDown"
                        filter
                        :disabled="!localSelectedForm"
                        append-to-body
                    />
                </div>
            </div>

            <div class="file-upload-section">
                <div class="upload-buttons">
                    <label for="fileInput" class="p-button">
                        <i class="pi pi-plus"></i>
                        <span class="p-button-label">Выберите файл</span>
                    </label>
                    <input id="fileInput" type="file" multiple @change="onFileSelect" style="display: none" />
                    <Button label="Очистить" icon="pi pi-times" class="p-button-danger" @click="clearFiles" :disabled="files.length === 0" />
                </div>

                <div class="file-list-wrapper">
                    <div class="file-list">
                        <div v-for="(file, index) in files" :key="index" class="file-item">
                            <div class="file-preview">
                                <img v-if="isImage(file)" :src="file.preview" :alt="file.name" />
                                <div v-else class="file-icon">
                                    <i class="pi pi-file"></i>
                                </div>
                            </div>
                            <div class="file-info">
                                <div class="file-name" :title="file.name">{{ file.name }}</div>
                                <div class="file-size">{{ formatFileSize(file.size) }}</div>
                            </div>
                            <Button icon="pi pi-times" class="p-button-sm p-button-text p-button-danger" @click="removeFile(index)" />
                        </div>
                        <div v-if="files.length === 0" class="empty-file-message">Файлы не выбраны</div>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <Button class="p-button" type="button" @click="confirmModal" :disabled="!canUpload">
                <span class="p-button-label">Загрузить</span>
            </Button>
            <Button class="p-button p-button-outlined" @click="closeModal">
                <span class="p-button-label">Отменить</span>
            </Button>
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import { getAllIntervalPeriods } from '@/api/form/formsPeriods';
import { jsonApiListParser } from '@/main/utils/common';
import { requestToastHandler } from '@/main/mixins';

export default {
    name: 'SimpleModal',
    mixins: [requestToastHandler],
    components: {
        Dialog,
        Button,
        Dropdown,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formList: {
            type: Array,
            default: () => [],
        },
        initialSelectedForm: {
            type: Object,
            default: null,
        },
        initialSelectedPeriod: {
            type: [Object, String],
            default: null,
        },
    },
    data() {
        return {
            localSelectedForm: null,
            localSelectedPeriod: null,
            periodList: [],
            files: [],
        };
    },
    computed: {
        localVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            },
        },
        canUpload() {
            return this.localSelectedForm && this.localSelectedPeriod && this.files.length > 0;
        },
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                // ВОССТАНОВЛЕНО: корректная инициализация при открытии
                this.localSelectedForm = this.initialSelectedForm;
                this.localSelectedPeriod = this.initialSelectedPeriod;
                this.files = [];

                if (this.localSelectedForm?.id) {
                    this.fetchFormPeriods();
                } else {
                    this.periodList = [];
                }
            }
        },
        'localSelectedForm.id': {
            handler(newVal) {
                if (newVal) {
                    this.fetchFormPeriods();
                    this.localSelectedPeriod = null;
                } else {
                    this.periodList = [];
                    this.localSelectedPeriod = null;
                }
            },
        },
    },
    methods: {
        async fetchFormPeriods() {
            if (!this.localSelectedForm?.distributionInterval?.id) return;

            try {
                const { data: allIntervalPeriods, included: incPeriods } = await getAllIntervalPeriods({
                    intervalId: this.localSelectedForm.distributionInterval.id,
                    filter: {
                        active: {
                            $eq: true,
                        },
                    },
                });
                this.periodList = jsonApiListParser(allIntervalPeriods, incPeriods);
            } catch (error) {
                this.$requestError(error.message);
            }
        },

        onFileSelect(event) {
            const selectedFiles = Array.from(event.target.files);
            selectedFiles.forEach((file) => {
                const fileObj = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: file,
                    preview: null,
                };
                if (this.isImage(file)) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        fileObj.preview = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                this.files.push(fileObj);
            });
            event.target.value = '';
        },

        removeFile(index) {
            this.files.splice(index, 1);
        },

        clearFiles() {
            this.files = [];
        },

        isImage(file) {
            return file.type && file.type.startsWith('image/');
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },

        closeModal() {
            this.$emit('update:visible', false);
        },

        confirmModal() {
            if (!this.canUpload) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Внимание',
                    detail: 'Выберите форму, период и загрузите файлы',
                    life: 3000,
                });
                return;
            }

            this.$emit('confirm', {
                form: this.localSelectedForm,
                period: this.localSelectedPeriod,
                files: this.files.map((f) => f.file),
            });
            this.closeModal();
        },
    },
};
</script>

<style scoped lang="scss">
.dialog-header-sections {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
}

.form-section,
.period-section {
    flex: 1;
}

.file-upload-section {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 16px;
    background: #fafafa;

    .upload-buttons {
        display: flex;
        gap: 8px;
        margin-bottom: 16px;

        label {
            cursor: pointer;
            margin: 0;
            display: inline-flex;
            align-items: center;

            i {
                margin-right: 4px;
            }
        }
    }

    .file-list-wrapper {
        max-height: 250px;
        overflow-y: auto;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background: white;

        .file-list {
            padding: 8px;

            .empty-file-message {
                text-align: center;
                color: #999;
                padding: 20px 0;
                font-size: 14px;
            }

            .file-item {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 10px;
                border-bottom: 1px solid #f0f0f0;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background: #f5f5f5;
                }

                .file-preview {
                    width: 40px;
                    height: 40px;
                    flex-shrink: 0;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }

                    .file-icon {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #f0f0f0;
                        border-radius: 4px;
                        font-size: 20px;
                        color: #999;
                    }
                }

                .file-info {
                    flex: 1;
                    min-width: 0;

                    .file-name {
                        font-weight: 500;
                        font-size: 14px;
                        margin-bottom: 2px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .file-size {
                        color: #888;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

::v-deep .customDropDown .p-dropdown {
    width: 100%;
}
</style>
